import { Facebook, Instagram, Pinterest, Youtube } from "./commonIcon";
import { links } from "./commonText";

export const HeaderMenus = [
  {
    name: "Overview",
    redirect: "#overview",
  },
  {
    name: "Testimonial",
    redirect: "#testimonial",
  },
  {
    name: "Features",
    redirect: "#features",
  },
  {
    name: "Download app",
    redirect: "#downloadapp",
  },
];

export const writeLetter = [
  {
    icon: "mail",
    title: "Living Memories",
    describe:
      "A photo that tells a story. Padami beautifully combines your printed photos with the videos that matter most. What looks like a traditional frame becomes a window into the past, allowing you to revisit the magic, the laughter, and the feeling of the moment instantly",
  },

  {
    icon: "mail",
    title: "Custom Gift",
    describe:
      "Give a gift that comes to life. Add a magical touch to personalized products. Whether it’s a birthday surprise, an anniversary keepsake, or a wedding memory, Padami allows you to hide video messages inside physical gifts, leaving a lasting impression that goes far beyond a simple image.",
  },
  {
    icon: "mail",
    title: "Secure Ordering",
    describe:
      'Your memories are in safe hands. Place orders for custom products. Your photos are uploaded to a secure environment, ensuring your privacy is protected. Once your order is placed, you have the power to "Edit the Magic" and link your private videos to your specific photos.',
  },
  {
    icon: "mail",
    title: "Scan for Magic",
    describe:
      "Instant joy at your fingertips. Experience the wonder of seeing your photo transform into a video. Once you receive your custom product, simply use the Padami app to scan the image. The linked video plays seamlessly on your screen, creating an immersive experience designed for everyone to enjoy.",
  },
];

export const postMemories = [
  {
    image: require("../../assets/images/post-memories1.png"),
    title: `Living <span className='highlight'> Memories</span>`,
    describe: `A photo that tells a story. Padami beautifully combines your printed photos with the videos that matter most. What looks like a traditional frame becomes a window into the past, allowing you to revisit the magic, the laughter, and the feeling of the moment instantly`,
    describe_side: "right",
  },
  {
    image: require("../../assets/images/post-memories2.png"),
    title: `Custom <span className='highlight'> Gift</span>`,
    describe: `Give a gift that comes to life. Add a magical touch to personalized products. Whether it’s a birthday surprise, an anniversary keepsake, or a wedding memory, Padami allows you to hide video messages inside physical gifts, leaving a lasting impression that goes far beyond a simple image.`,
    describe_side: "left",
  },
  {
    image: require("../../assets/images/post-memories3.png"),
    title: `Secure <span className='highlight'> Ordering</span>`,
    describe: `Your memories are in safe hands. Place orders for custom products. Your photos are uploaded to a secure environment, ensuring your privacy is protected. Once your order is placed, you have the power to "Edit the Magic" and link your private videos to your specific photos.`,
    describe_side: "left",
  },
  {
    image: require("../../assets/images/post-memories3.png"),
    title: `Scan <span className='highlight'> for Magic</span>`,
    describe: `Instant joy at your fingertips. Experience the wonder of seeing your photo transform into a video. Once you receive your custom product, simply use the Padami app to scan the image. The linked video plays seamlessly on your screen, creating an immersive experience designed for everyone to enjoy.`,
    describe_side: "right",
  },
];

export const footerText = [
  {
    title: "FEATURES",
    describe: [
      { name: "Create Living Memories", redirect: "", icon: "" },
      { name: "The Perfect Custom Gift", redirect: "", icon: "" },
      { name: "Safe & Secure Ordering", redirect: "", icon: "" },
      { name: "Scan for Magic", redirect: "", icon: "" },
    ],
  },
  {
    title: "Social links",
    describe: [
      {
        name: "Instagram",
        redirect: links?.instagram_url,
        icon: <Instagram />,
      },
      { name: "Facebook", redirect: links?.facebook_url, icon: <Facebook /> },
      { name: "Youtube", redirect: links?.youtube_url, icon: <Youtube /> },
    ],
  },
  {
    title: "Privacy and Terms ",
    describe: [
      { name: "Privacy", redirect: links?.privacy_url, icon: "" },
      { name: "Terms", redirect: links?.privacy_url, icon: "" },
    ],
  },
  {
    title: "Contact",
    describe: [
      {
        name: "2/410 Thottipalayam , Somanur, Coimbatore-641668, Tamilnadu",
        redirect: "",
        icon: "",
      },
      {
        name: "sisulogs@gmail.com",
        redirect: "mailto:sisulogs@gmail.com",
        icon: "",
      },
    ],
  },
];

export const feedback = [
  {
    title: "Pranvika",
    describe:
      "I'm very excited to use this app for my baby where I can able to store all my emotional feelings about day to day life of my bby activities,baby pics,vdos and Its very easy to access the photos based on occasions and it's very useful in storing all by baby's moments",
  },

  {
    title: "Karthiga",
    describe:
      "The app is very cool to use and it's notifying the vaccination dates where we used to miss all the time.the best app to store the memories of baby and the data is protective",
  },
];
